import { Head, usePage } from '@inertiajs/react';

import {
  type LedgerItem,
  MetaDot,
  RecordBackLink,
  RecordBody,
  RecordFiles,
  RecordLedger,
  RecordMasthead,
  RecordSection,
  RecordSheet,
} from '@/components/admin/detail/RecordSheet';
import { StatusActionBar } from '@/components/admin/detail/StatusActionBar';
import { StatusStamp } from '@/components/admin/detail/StatusStamp';
import { RequestSections } from '@/components/admin/requests/RequestSections';
import { getRequestTypeConfig } from '@/data/requestsConfig';
import type { Request } from '@/pages/Admin/Requests';

interface RequestDetailProps {
  request: Request;
  [key: string]: unknown;
}

export default function RequestDetail() {
  const { request } = usePage<RequestDetailProps>().props;
  const config = getRequestTypeConfig(request.type);
  const name = (request.payload['name'] as string | undefined) ?? 'Anónimo';

  const ledger: LedgerItem[] = [
    { label: 'Submetido', value: new Date(request.submittedAt).toLocaleString('pt-PT') },
  ];
  if (request.handledBy) {
    ledger.push({
      label: 'Tratado por',
      value: request.handledAt
        ? `${request.handledBy} · ${new Date(request.handledAt).toLocaleDateString('pt-PT')}`
        : request.handledBy,
    });
  }

  return (
    <>
      <Head title={`${config.label} — Administração`} />
      <RecordBackLink href="/requests" label="Voltar a Pedidos" />

      <RecordSheet>
        <RecordMasthead
          typeTag="Pedido de serviço"
          title={config.label}
          topRight={<StatusStamp status={request.status} />}
          meta={
            <>
              <span className="text-primary font-bold tracking-wide">{request.referenceCode}</span>
              <MetaDot />
              <span>{name}</span>
              <MetaDot />
              <span>{new Date(request.submittedAt).toLocaleString('pt-PT')}</span>
            </>
          }
        />
        <RecordBody>
          <RequestSections type={request.type} payload={request.payload} />
          {request.files.length > 0 && (
            <RecordSection label="Anexos">
              <RecordFiles files={request.files} />
            </RecordSection>
          )}
        </RecordBody>
        <RecordLedger items={ledger} />
        <StatusActionBar
          basePath="/requests"
          id={request.id}
          status={request.status}
          resolveLabel="Marcar como resolvido"
        />
      </RecordSheet>
    </>
  );
}
